import {CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';

import {Observable, of} from 'rxjs';
import {catchError, filter, switchMap, take, tap} from 'rxjs/operators';
import {select, Store} from '@ngrx/store';

import {ApplicationState} from '../../application-state/store';
import {DocumentDeliveryProvidersActions} from '../store';
import {DocumentDeliveryProvidersSelectors} from '../store/selectors';

@Injectable()
export class DocumentDeliveryProvidersLoadedGuard implements CanActivate {

  constructor(private store$: Store<ApplicationState>) {
  }

  canActivate(): Observable<boolean> {

    return this.readDocumentDeliveryProvidersDone().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  readDocumentDeliveryProvidersDone(): Observable<boolean> {

    return this.store$.pipe(
      select(DocumentDeliveryProvidersSelectors.isLoaded),
      tap((loaded: boolean) => {
        if (!loaded) {
          this.store$.dispatch(DocumentDeliveryProvidersActions.ReadDocumentDeliveryProviders());
        }
      }),
      filter(loaded => loaded),
      take(1)
    );
  }
}
